import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { propTypes } from 'react-bootstrap/esm/Image';

const StyledDrawer = ({ isDrawerOpen }) => {
    const [state, setState] = useState({
        right: false,
    });

    useEffect(() => {
        setState({ right: isDrawerOpen });
    }, [isDrawerOpen]);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const list = () => (
        <Box sx={{ width: 600 }} role="presentation">
            <div>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">davie.ai Plans</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div style={{ fontWeight: '500' }}>3 plans are available:</div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>Essentials</span> is suited for an advertiser who only has one business to
                                advertise. It will provide all you need to create campaigns for Paid Search Engines and will place your ads on most
                                advertising exchanges connecting you to mobile phones, computers, and internet connected TVs and even out of home
                                digital advertising.
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>Pro</span> is best for advertisers with multiple companies or brands that have
                                different types of products and services. For advertisers with budgets larger than $5,000 per month, as your media
                                commission rate discount will pay for davie.ai’s monthly charge and you’ll even receive more free ads on our mobile
                                apps and websites. It’s also suitable for small advertising agencies and advertising professionals.
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>Pro +</span> is has the features of davie.ai Pro Plan, but with a greater media
                                commission discount. Agencies or Advertisers with monthly budget commitments greater than $12,000 will benefit from
                                our Pro + Plan
                            </div>
                            <br />
                            <div>
                                Custom Plans are available for advertisers and agencies with monthly budget commitments greater than $100,000 per
                                month.
                            </div>
                            <br />
                            <div>
                                For more information, email <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our
                                customer success team will get back to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">How davie.ai works</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                <span style={{ fontWeight: '500' }}>davie.ai</span> is software that uses artificial intelligence to guide advertisers
                                as they market their products and services.
                            </div>
                            <br />
                            <div>
                                Users train davie by answering questions about their business, products and services, and best customers, and then
                                davie suggests some digital advertising strategies. Over time davie.ai will keep learning based on the response to ads
                                and campaigns.
                            </div>
                            <br />
                            <div>
                                Remember davie.ai is just an assistant and will rely on you to collaborate by refining his suggested strategies,
                                budgets, and messaging.
                            </div>
                            <br />
                            <div>
                                After you train davie, he will look at the information you’ve entered, scan your website, and other references related
                                to your business and offering. When he presents your strategy, download it, and save it. You can also retrain him
                                whenever you want by selecting Train davie.ai from your dashboard.
                            </div>
                            <br />
                            <div>
                                davie specializes in creating and placing digital advertising campaigns on search engines, thousands of smartphones,
                                websites, internet-connected TV, and Radio stations, and even digital out of home media outlets. davie also lets you
                                place ads on our private network of mobile apps and websites many of those ads will be free to you, especially if you
                                participate in our “We pay you to advertise” program.
                            </div>
                            <br />
                            <div>
                                If you have any questions, you can visit <a href="wiki.davie.ai"> wiki.davie.ai</a> or email{' '}
                                <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our customer success team will get back
                                to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Getting Started</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                It’s always best to start by teaching davie about your business and the products and services you offer. If you’re
                                business advertiser, you will train davie when you sign up. If you’re an agency or managing multiple advertisers, it’s
                                best to train davie for each advertiser to ensure that he’s suggesting the right messages, keywords, and targets.
                            </div>
                            <br />
                            <div>
                                If you’re an agency or owner of multiple companies and brands using our Pro or Pro + plans, you can set up your
                                advertisers under your agency account, selecting “Agency” and “Add/View Advertisers from the top menu. Then you can
                                start advertising, one campaign at a time.
                            </div>
                            <br />
                            <div>
                                To create a campaign, click New Campaign on your dashboard, (or “Campaigns” from the top menu bar, then select the
                                advertiser in the upper right “Current Advertiser” box, select the campaign type and follow the prompts. Once you
                                complete the campaign, enter your budget, and confirm your payment method, davie will run your campaign on Google or
                                Bing or on thousands of other ad-supported digital media outlets.
                            </div>
                            <br />
                            <div>
                                davie usually recommends that you start with a few campaigns to confirm that your messaging and targeting is
                                effective. Allocate your budget across multiple campaigns including programmatic, paid search and mobile platforms.
                            </div>
                            <br />
                            <div>It’s useful to return to the dashboard to navigate the process.</div>
                            <br />
                            <div>
                                If you have any questions, you can visit <a href="wiki.davie.ai"> wiki.davie.ai</a> or email{' '}
                                <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our customer success team will get back
                                to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Training davie</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                davie uses artificial intelligence to combine the information you provide him, what your website says about you, what
                                other businesses like yours is doing effectively to create strategies, messaging, targeting and campaign suggestions.
                            </div>
                            <br />
                            <div>
                                When you sign up or set-up and advertiser account, you’ll have an opportunity to teach davie about your business. You
                                can always train him again as often as you like, if you have more or different information that you’d like davie to
                                know.
                            </div>
                            <br />
                            <div>
                                davie’s suggestions for campaign strategy and messaging is a foundation for you to refine. You will always know more
                                about your business and customers than davie will, so change what doesn’t make sense to you.
                            </div>
                            <br />
                            <div>
                                davie will use the information you provide him to suggest paid search campaigns, keywords, messaging and the like. You
                                should also review and refine those suggestions are you see fit.
                            </div>
                            <br />
                            <div>
                                When you advertise on davie’s affiliated websites and mobile apps like davie deals, users will also provide feedback
                                to davie – helping to define consumer “demand profiles” making your targeting even more effective.
                            </div>
                            <br />
                            <div>
                                Hint: It’s best not to use special characters like #, !, *, or apostrophes like “ ’s ”, because some digital outlets
                                won’t use keywords or targeting information if they include those characters.
                            </div>
                            <br />
                            <div>If you want to retrain davie, from the dashboard select “Train davie.ai” and answer questions.</div>
                            <br />
                            <div>
                                If you have any questions, you can visit <a href="wiki.davie.ai"> wiki.davie.ai</a> or email{' '}
                                <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our customer success team will get back
                                to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Account Management</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                When you sign up for your davie.ai account, you’ll complete the form indicating the name and title of the account
                                “owner” his or her contact information and billing address and indicated if you have an agency or in-house agency
                                managing multiple companies or brands.{' '}
                            </div>
                            <br />
                            <div>
                                If you have the Pro or Pro+ plan and have indicated that you represent an agency or in-house advertising manager with
                                multiple companies or brands, you will see a menu choice for “Agency” on the top menu bar.
                            </div>
                            <br />
                            <div>
                                To edit your agency account information, you can select “Agency Information” from the menu and edit the content. You
                                can also add or view your advertiser accounts from the Agency menu selection.
                            </div>
                            <br />
                            <div>
                                If you are an Essential plan user, you will be able to manage your account information from the Advertiser selection
                                on the top menu bar.
                            </div>
                            <br />
                            <div>
                                If you wish to update your account or add or change payment methods, you can also click on the gear icon on the bottom
                                menu bar.
                            </div>
                            <br />
                            <div>
                                If you have any questions, you can visit <a href="wiki.davie.ai"> wiki.davie.ai</a> or email{' '}
                                <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our customer success team will get back
                                to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Campaigns</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>davie.ai helps you create and post campaigns for various types of digital media outlets.</div>
                            <br />
                            <div>
                                To learn more about the type of campaigns davie.ai recommends, train davie and get his campaign strategy advice.
                            </div>
                            <br />
                            <div>
                                <div style={{ fontWeight: '500' }}>davie is designed to create campaigns for:</div>

                                <ul style={{ listStyleType: 'square' }}>
                                    <li>paid search campaigns like Google and Bing</li>
                                    <li>Programmatic campaigns placing ads on websites, phones, and connected TVs</li>
                                    <li>davie.ai’s affiliated mobile apps and websites matching buyers and sellers</li>
                                    <li>Digital Out of Home media outlets</li>
                                    <li>Paid Social Media Ads</li>
                                    <li>Video or Audio Ads</li>
                                    <li>Rich Content email campaigns</li>
                                </ul>
                            </div>
                            <br />
                            <div>
                                Before creating a campaign, confirm that the Advertiser Name is in the “Current Advertiser” box at the top right of
                                the top menu bar…or change the Advertiser to the correct one, if you’re managing more than one advertiser.
                            </div>
                            <br />
                            <div>
                                To create campaigns from your dashboard, select “New Campaign” or “Campaigns” from the top menu bar, then select the
                                campaign type and hit “Next”, follow the prompts to Enter the Advertiser or Brand, then the category from the list
                                that best fits your offering.
                            </div>
                            <br />
                            <div>
                                Enter the URL for your website landing page where you want viewers of the campaign to visit when they click on your
                                ad. Use the https://www.domainname.com format for your website. It’s best to check that the landing page URL is
                                working before moving forward.
                            </div>
                            <br />
                            <div>
                                Select the location where you want your ads to run. You can select the whole country by entering “United States” or
                                type a state name, a county, city, or zip code or series of these. When you see the list of locations that matches
                                what you’ve typed, just click on the one that you want. When you’re done selecting locations, click “Next”.
                            </div>
                            <br />
                            <div>
                                Enter the date you’d like your campaign to start running ads and when you’d like the campaign to stop. Note that some
                                media outlets require a review of your campaign to make sure it meets their standards and requirements.
                            </div>
                            <br />
                            <div>
                                For example, most won’t accept ads for tobacco products, adult materials etc. Many won’t accept ads for firearms, some
                                won’t accept ads for alcoholic beverages. You can create your campaigns to run in the future and it makes sense to
                                start after submitting to give media outlets time to approve the ad.
                            </div>
                            <br />
                            <div>For display or banner ads most media outlets require that your company, brand name or logo appears on the ad.</div>
                            <br />
                            <div>
                                For Paid Search campaigns you can either enter the information or ask davie.ai to generate suggestions. davie will
                                review your training information, your website, and other sources to generate messaging and keywords, etc. You should
                                review and refine all of davie.ai’s suggestions, and make sure that they meet with your approval and that the limits
                                to message lengths are appropriate for the search engine requirements (note any items you should adjust appear in
                                red).
                            </div>
                            <br />
                            <div>
                                For campaigns with display ads, upload your ad remembering that only certain size ads are acceptable for certain
                                mobile apps, websites and the like and video ad requirements also vary by media outlet. davie will guide you to make
                                sure you have an acceptable ad. You may be required to confirm the file name of a display ad or create a new name if
                                you’d like.
                            </div>
                            <br />
                            <div>
                                When you’re happy with the campaign information and the content you’ve entered, click on “Next” to enter the budget
                                for the campaign. The budget will be spread equally over the number of days of the campaign.
                            </div>
                            <br />
                            <div>
                                Once you enter a campaign, you’ll have an opportunity to review it and make changes if you want, just hit the “Back”
                                button until you see what you want to change. Edit it and move forward through the campaign, confirm it and add or
                                click on your preferred payment method, then hit the “Purchase and Run” button and davie will get busy posting your
                                campaigns to the appropriate media outlets.
                            </div>
                            <br />
                            <div>
                                You can also can copy an existing campaign and edited it to create a new one, to make it easy to run similar campaigns
                                aging or for additional dates.
                            </div>
                            <br />
                            <div>You will receive an email confirming that the campaign is accepted and will be running.</div>
                            <br />
                            <div>
                                If you have any questions, you can visit <a href="wiki.davie.ai"> wiki.davie.ai</a> or email{' '}
                                <a href="advertise@lifewisedigital.com"> advertise@lifewisedigital.com</a> and our customer success team will get back
                                to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Creating Ads</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                To run digital advertising campaigns, you will need to have or produce at least one of a few types of ads.{' '}
                                <span style={{ fontWeight: '500' }}>These include:</span>
                                <ul style={{ listStyleType: 'square' }}>
                                    <li>Text Ads (for paid search or certain mobile campaigns)</li>
                                    <li>Display or “Banner” ads with graphical images and text</li>
                                    <li>Video Ads</li>
                                    <li>Audio Ads</li>
                                    <li>And certain creative objects for use in social media, digital out of home or email campaigns</li>
                                </ul>
                            </div>
                            <br />
                            <div>
                                If you have an ad on your computer or phone, or stored on the cloud, you can just upload it in the campaign process.
                            </div>
                            <br />
                            <div>
                                If you don’t have an ad ready, you can use davie.ai’s ad creator, or any other graphic tools like Canva or similar
                                software tools to create an ad. You can use a template, photo, or just a plain background.
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>A few things to remember:</span>
                                <ul style={{ listStyleType: 'square' }}>
                                    <li>
                                        Make sure that you honor other people’s copyrights and don’t just grab someone else’s creative or copy their
                                        ads
                                    </li>
                                    <li>Only certain ad sizes are allowed on most media outlets</li>
                                    <li>Video and audio file types, sizes and lengths are limited</li>
                                    <li>Make sure your ads are branded with your name or logo</li>
                                </ul>
                            </div>
                            <br />
                            <div>
                                Ads should always include a clear “Call to Action” or what you’d like the viewer to do when they see your ad like
                                “Click to Learn More” or “Call Now”.
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>
                                    davie.ai recommends these best ad sizes for display or banner ads (in pixels):
                                </span>
                                <ul style={{ listStyleType: 'square' }}>
                                    <li>300 X 250</li>
                                    <li>160 X 600</li>
                                    <li>728 X 90</li>
                                    <li>300 X 600</li>
                                    <li>320 X 50</li>
                                </ul>
                                <div>File types must be .jpeg or .png</div>
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>For video files:</span>
                                <ul style={{ listStyleType: 'square' }}>
                                    <li>Lengths should be either 5, 15, 30, or 60 seconds</li>
                                    <li>File Type should be MP4 (MPEG4)</li>
                                </ul>
                            </div>
                            <br />
                            <div>
                                <span style={{ fontWeight: '500' }}>For audio files:</span>
                                <ul style={{ listStyleType: 'square' }}>
                                    <li>Lengths should be either 15 or 30 seconds</li>
                                    <li>File Type should MP3 (MPEG-1 Audio Layer 3)</li>
                                </ul>
                            </div>
                            <br />
                            <div style={{ fontWeight: '500' }}>Using davie.ai’s Ad Creative Tool</div>
                            <br />
                            <div>Click on “New Creatives” from the dashboard or “Creatives” from the top menu bar, then pick “Ad Builder”,</div>
                            <br />
                            <div>
                                Select the ad size and click “Next”. Then click “Next” to start a new ad, Pick a background color and image on the
                                next screen – select an image and use the tool box in the upper right of the screen to change sizes, colors, etc. Add
                                text. You can add as many images as you think fits well, include your logo, and you can add a photo of the product or
                                your location, and make sure you have a call to action for the viewer.
                            </div>
                            <br />
                            <div>
                                If you need help with creatives, email <a href="advertise@lifewisedigital.com "> advertise@lifewisedigital.com </a>
                                and our customer success team will get back to you ASAP.
                            </div>
                            <br />
                            <div>
                                If you need professional help with your creative assets, you can also check out{' '}
                                <a
                                    href="https://www.davieexperts.com
"
                                >
                                    {' '}
                                    https://www.davieexperts.com{' '}
                                </a>
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Lead Gen Pages and Campaigns</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>One of davie.ai’s most popular features if the ability to create a campaign to create and qualify sales leads.</div>
                            <br />
                            <div>
                                To create a lead gen campaign, you start by building a landing page (which can be a stand-alone web page or imbedded
                                in your website).
                            </div>
                            <br />
                            <div>
                                Click on Lead Gen from the dashboard or top menu bar to create a landing page. Confirm or select the advertiser for
                                the campaign. Then create the headline and subtext for your landing page –
                            </div>
                            <br />
                            <div>Hint: It’s important to highlight your offering and value proposition for the viewer to see it right away.</div>
                            <br />
                            <div>
                                Then select the colors for buttons, hit next and select the text color for the words that will appear on the button
                                and click next. Then upload your logo that will appear on your page and hit next. Then upload a background image that
                                will be the background for the whole page or just a background color if you prefer.
                            </div>
                            <br />
                            <div>
                                Next, you’ll be able to create the qualifying questions you can ask a potential customer to ensure that they are the
                                right customer for you. For example, if you are a roofing contractor, you can create questions like, “What is the
                                address of your home?” or “What type of Roof to you have?” and you can dictate the type of answers you want. You can
                                create a free text type response where they can explain what they are looking for, or you can let them select the list
                                of possible answers that you are seeking…like roof types “Slate, Shingle, Metal, Clay, or other”.
                            </div>
                            <br />
                            <div>The user will always be required to enter contact information including name, email or phone.</div>
                            <br />
                            <div>
                                After you’ve created as many questions as you’d like a consumer to answer, click next and enter the email for the
                                person who will receive the lead. When a viewer of the ad campaign clicks on the ad, lands on the landing page, and
                                answers the questions, you’ll get an email with the information they entered and their contact information.
                            </div>
                            <br />
                            <div>
                                You see a facsimile of the page you created and have the opportunity to go back and change it or click update to
                                create the page, the URL and the code to imbed it in your website if you’re interested.
                            </div>
                            <br />
                            <div>You’ll see the landing page URL and that would be entered into a campaign for viewers to click into your page.</div>
                            <br />
                            <div>
                                If you need help with creating a landing page, email
                                <a
                                    href=" advertise@lifewisedigital.com
"
                                >
                                    {' '}
                                    advertise@lifewisedigital.com{' '}
                                </a>{' '}
                                and our customer success team will get back to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography fontWeight="bold">Analytics</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <div>
                                To see how your ads are doing, davie.ai accumulates data from media outlets and from our proprietary properties and
                                posts them regularly to provide performance analytics.
                            </div>
                            <br />
                            <div>
                                For your campaigns, you will see the campaign information listed and its status and the campaign performance to date.
                            </div>
                            <br />
                            <div>
                                If you need have questions about your campaigns, email
                                <a
                                    href=" advertise@lifewisedigital.com
"
                                >
                                    {' '}
                                    advertise@lifewisedigital.com{' '}
                                </a>{' '}
                                and our customer success team will get back to you ASAP.
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        </Box>
    );

    return (
        <div>
            {['right'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                        {list(anchor)}
                    </Drawer>
                </React.Fragment>
            ))}
        </div>
    );
};

StyledDrawer.propTypes = {
    isDrawerOpen: propTypes.bool,
};

export default StyledDrawer;
